import React from 'react';
import { Grid, Icon, Card, Header } from 'semantic-ui-react';
import RemoveFlightLabel from '../RemoveFlightLabel';
import FlightDate from '../FlightDate';
import 'moment-duration-format';

export default class Flight extends React.Component {
  render = () => {
    const {
      flight,
      status,
      actionButtons: ActionButtons,
      labels: Labels
    } = this.props;
    const hasAirline = flight.airline;
    return (
      <Card fluid style={{ border: !hasAirline ? '2px solid red' : 'initial' }}>
        <Card.Content>
          <Header as="h4">
            {flight.id === this.props.claimFlightId && (
              <Icon name="warning circle" />
            )}Flight {flight.id}
          </Header>
          {this.props.handleRemoveFlight &&
            flight.id !== this.props.claimFlightId && (
              <RemoveFlightLabel
                flight={flight}
                handleRemoveFlight={this.props.handleRemoveFlight}
              />
            )}
          <Grid columns={3}>
            <Grid.Row>
              <Grid.Column>
                <strong style={{ color: !hasAirline ? 'red' : 'initial' }}>
                  Airline:
                </strong>
                {hasAirline &&
                  ` ${flight.airline.name}(${flight.airline.iata})`}
              </Grid.Column>
              <Grid.Column>
                <strong>Airport Origin:</strong> {flight.airportOrigin.name} ({
                  flight.airportOrigin.iata
                })
              </Grid.Column>
              <Grid.Column>
                <strong>Airport Destination:</strong>{' '}
                {flight.airportDestination.name} ({
                  flight.airportDestination.iata
                })
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column>
                <strong>Number:</strong> {flight.number}
              </Grid.Column>
              <Grid.Column>
                <strong>Local Departure Date:</strong>{' '}
                <FlightDate date={flight.localDepartureDate} />
              </Grid.Column>
              <Grid.Column>
                <strong>Local Arrival Date:</strong>{' '}
                <FlightDate date={flight.localArrivalDate} />
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Labels flight={flight} status={status} />
            </Grid.Row>
            {ActionButtons && (
              <Grid.Row>
                <ActionButtons />
              </Grid.Row>
            )}
          </Grid>
        </Card.Content>
      </Card>
    );
  };
}



// WEBPACK FOOTER //
// ./src/component/FlightView/Flight.js